// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as RestApi$DvmAdminFrontendFr from "../../../api/RestApi.bs.js";
import * as Dealer_Detail_Types$DvmAdminFrontendFr from "./Dealer_Detail_Types.bs.js";

function fetchDealerDetail(dealerId, userManager, setResult, startDate, selectedRole) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.call("GET", Dealer_Detail_Types$DvmAdminFrontendFr.dealerDetail_decode, undefined, userManager, selectedRole, "/dealers/" + dealerId + "/" + startDate + "/detail").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          var dealer = result._0;
          return Curry._1(setResult, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: dealer
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

function fetchAgents(userManager, setTablePage, queryParams, selectedRole) {
  Curry._1(setTablePage, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.call("GET", Dealer_Detail_Types$DvmAdminFrontendFr.Agent.searchResult_decode, undefined, userManager, selectedRole, "/dealers/search/agents" + queryParams + "").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          var searchTable = result._0;
          return Curry._1(setTablePage, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: searchTable
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setTablePage, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

var Types;

export {
  Types ,
  fetchDealerDetail ,
  fetchAgents ,
}
/* RestApi-DvmAdminFrontendFr Not a pure module */
